import {
    UPDATE_COMPANIES
    , UPDATE_GROUPS
    ,DELETE_GROUP_BYID
    ,DELETE_COMPANY_BYID
}from "./action_types"
export const update_companies =(companies)=>({type:UPDATE_COMPANIES,data:companies})
export const update_groups =(groups)=>({type:UPDATE_GROUPS,data:groups})
export const delete_group_by_id =(id)=>({type:DELETE_GROUP_BYID,data:id})
export const delete_company_by_id =(id)=>({type:DELETE_COMPANY_BYID,data:id})